type MaybeClassName = (string | boolean) | null | undefined;

export function cx(...classes: MaybeClassName[]): string {
  return classes.filter(validClass => validClass).join(' ');
}
